import vmFunctions from '..';
import { vmTypes } from '../../../global-prop-types';
import { emptyArray, emptyNull, isObj } from '../../../shared/misc';
import { mapData } from '../../dataMapping';
import { vmTreeGet, vmTreeSet } from '../../vmTree';
import { isArr } from '../vmArray';

export const getByKey = (obj, key) => obj?.[key];
export const getByPath = (obj, vmPath) => vmTreeGet(obj, vmPath);
export const setByPath = (obj, vmPath, value) => vmTreeSet(obj, vmPath, value);
export const keys = (obj) => (isObj(obj) ? Object.keys(obj) : emptyArray);
export const entries = (obj) => (isObj(obj) ? Object.entries(obj) : emptyArray);

export const groupBy = (arrMap, funcMap, options = emptyNull) => {
  const { dataMappingVmType = vmTypes.mapArrayElements } = options;
  const mapDataOptions = { dataMappingVmType };
  const arr = mapData({ vmFunctions }, arrMap, null, mapDataOptions);
  const func = (el) => mapData({ el, vmFunctions }, funcMap, null, mapDataOptions);
  return isArr(arr) ? Object.groupBy(arr, func) : emptyNull;
};
